import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import socialPrintTemplateStrings from './contextualStrings';
import ContextualString from '../../../../../../../../components/contextual/ContextualString';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    album_type: PropTypes.string.isRequired,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    organization_name: PropTypes.string.isRequired,
  }).isRequired,
};

const SocialPrintTemplateWGNoJoinCode = ({ account, albumFolder }) => {
  return (
    <Fragment>
      <p className="marketing-material-social-main-copy">
        <ContextualString
          id="webGalleryMainCopy"
          defaultMessage="{orgName} is excited to announce that you’ll be able to view, download, and share all your favorite photos through our Waldo Photos gallery!"
          type={albumFolder.album_type}
          subtype={albumFolder.album_subtype}
          strings={socialPrintTemplateStrings}
          values={{
            orgName: account.organization_name,
          }}
        />
      </p>
      <p className="marketing-material-social-cta-copy">
        Visit our profile page below to view your photos:
      </p>
      <p className="marketing-material-social-target-copy">
        waldophotos.com/@{account.username}
      </p>
    </Fragment>
  );
};

SocialPrintTemplateWGNoJoinCode.propTypes = propTypes;

export default SocialPrintTemplateWGNoJoinCode;
